import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { AnimTap, EColors2, EFonts, EVariables } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    iconSet: IconPrefix;
    iconName: IconName;
    title: string;
    disabled?: boolean;
    onClick?: () => void;
    selected?: boolean;
    className?: string;
}

export const MenuItem = (props: Props): JSX.Element => {
    return (
        <S_MenuItem
            className={props.className}
            onClick={() => {
                if (props.onClick && !props.disabled) {
                    props.onClick();
                }
            }}
            $selected={props.selected}
            {...AnimTap}
            $disabled={props.disabled}
        >
            {props.iconName && (
                <S_FontIcon $disabled={props.disabled} icon={[props.iconSet, props.iconName]} />
            )}
            <S_Title $disabled={props.disabled} $selected={props.selected}>
                {props.title}
            </S_Title>
        </S_MenuItem>
    );
};

const S_MenuItem = styled(motion.div)<{ $selected: boolean; $disabled: boolean }>`
    display: inline-flex;
    padding: 13px 21px;
    align-items: center;
    gap: 17px;
    border-radius: ${EVariables.Radius1};
    width: fit-content;
    cursor: pointer;
    user-select: none;
    ${(props) => {
        if (props.$disabled) {
            return css`
                background-color: white;
                cursor: not-allowed;
            `;
        } else if (props.$selected) {
            return css`
                background-color: ${EColors2.GREY2};
            `;
        } else {
            return css`
                &:hover {
                    background-color: ${EColors2.DARK};
                    ${S_Title} {
                        color: ${EColors2.WHITE};
                    }
                    svg {
                        color: white;
                    }
                }
            `;
        }
    }}
`;

const S_FontIcon = styled(FontAwesomeIcon)<{ $disabled: boolean }>`
    color: ${EColors2.DARK};
    font-size: 16px;
    ${(props) => {
        if (props.$disabled) {
            return css`
                color: #d2d2d2;
            `;
        }
    }}
`;

const S_Title = styled.div<{ $selected: boolean; $disabled: boolean }>`
    color: ${EColors2.DARK};
    font-family: ${EFonts.Bold};
    font-size: 16px;
    ${(props) => {
        if (props.$disabled) {
            return css`
                color: #d2d2d2;
                text-decoration: line-through;
            `;
        } else if (props.$selected) {
            return css`
                color: ${EColors2.DARK};
            `;
        }
    }}
`;
